import React, { useContext, useState } from 'react';
import { Context } from '../../context/AppContext';
import removeSpaces from '../../utils/removeSpaces';
import hiddenNumber from '../../utils/hiddenNumber';
import RoundButton from '../RoundButton';
import './styles.css';

const PhoneNumberHidden = ({
  number = '',
  unhide = false,
  children,
  prependChildren,
  triggerOnClick,
  onShow,
  ...props
}) => {
  const {
    media: { mobile },
  } = useContext(Context);

  const [show, setShow] = useState(unhide);

  const onClick = () => {
    setTimeout(() => {
      setShow(true);
      if (onShow) onShow(true);
    }, 400);
  };

  return (
    <RoundButton
      {...props}
      data-phone={mobile || show ? 'full' : 'hidden'}
      href={mobile || show ? `tel:${removeSpaces(number)}` : null}
      onClick={() => onClick()}
    >
      {children ||
        (mobile || show ? (
          <>
            {prependChildren}
            <span className="PhoneNumberHidden__root">{number}</span>
          </>
        ) : (
          <>
            {prependChildren}
            <span className="PhoneNumberHidden__root PhoneNumberHidden__root--hidden">
              {hiddenNumber(number)}
            </span>
          </>
        ))}
    </RoundButton>
  );
};

export default PhoneNumberHidden;
